import React, { Fragment } from 'react';
import Headroom from 'react-headroom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { withRouter } from 'react-router-dom';

import config from '../../config';
import NavbarMobile from './NavbarMobile';
import NavbarDesktop from './NavbarDesktop';
import { MobileScreen, DesktopScreen } from '../ResponsiveScreens';
import { logout, openLoginModal, openSignUpModal } from '../../redux/actions/authActions';
import CartIcon from './CartIcon';

const fallbackUserAvatar = 'https://s3.amazonaws.com/honeyguide/assets/user-fallback.png';

const socialMediaLinks = [
  { text: 'facebook', link: 'https://www.facebook.com/honeyguideapp/' },
  { text: 'instagram', link: 'https://www.instagram.com/honeyguideapps/' },
  { text: 'youtube', link: 'https://youtube.com/honeyguideapps' },
  { text: 'whatsapp', link: 'https://api.whatsapp.com/send?phone=+977-9801916215' },
  { text: 'viber', link: 'https://viber.com/+Honeyguideapps' },
];

function NavBar(props) {
  const { openLoginModal, openSignUpModal, userInfo } = props;
  return (
    <Fragment>
      <DesktopScreen>
        <Headroom upTolerance={0} downTolerance={2}>
          <div className="top-contact">
            <div className="container topbar-container">
              <div className="social-bar">
                <ul>
                  {socialMediaLinks.map(({ text, link }) => (
                    <li key={text}>
                      <a href={link}><img src={`https://s3.amazonaws.com/honeyguide/assets/icons/${text}.png`} alt={text} /></a>
                    </li>)
                  )}
                </ul>
                <ul className="contact-cta">
                  <li>
                    <a href={`tel:${config.honeyguidePhoneNumber}`}><img src="https://s3.amazonaws.com/honeyguide/assets/icons/phone.png" alt="" /><span className="d-none d-lg-inline">{config.honeyguidePhoneNumber}</span></a>
                  </li>
                  <li>
                    <a href={`mailto:${config.honeyguideEmail}`}><img src="https://s3.amazonaws.com/honeyguide/assets/icons/mail.png" alt="" /><span className="d-none d-lg-inline">{config.honeyguideEmail}</span></a>
                  </li>
                </ul>
              </div>
              <div className="action-bar">
                <CartIcon />
                {
                  !userInfo && (
                    <Fragment>
                      <Button color="toplogin" size="sm" onClick={openLoginModal}>Log in</Button>
                      <Button color="topsignup" size="sm" onClick={openSignUpModal}>Sign up</Button>
                    </Fragment>
                  )
                }
              </div>
            </div>
          </div>
          <NavbarDesktop {...props} />
        </Headroom>
      </DesktopScreen>

      <MobileScreen>
        <Headroom>
        <div className="top-contact">
            <div className="container topbar-container">
              <div className="social-bar">
                <ul>
                  {socialMediaLinks.map(({ text, link }) => (
                    <li key={text}>
                      <a href={link}><img src={`https://s3.amazonaws.com/honeyguide/assets/icons/${text}.png`} alt={text} /></a>
                    </li>)
                  )}
                </ul>
                <ul className="contact-cta">
                  <li>
                    <a href={`tel:=${config.honeyguidePhoneNumber}`}><img src="https://s3.amazonaws.com/honeyguide/assets/icons/phone.png" alt="" /><span className="d-none d-lg-inline">{config.honeyguidePhoneNumber}</span></a>
                  </li>
                  <li>
                    <a href={`mailto:${config.honeyguideEmail}`}><img src="https://s3.amazonaws.com/honeyguide/assets/icons/mail.png" alt="" /><span className="d-none d-lg-inline">{config.honeyguideEmail}</span></a>
                  </li>
                </ul>
              </div>
              <div className="action-bar">
                <CartIcon />
              </div>
            </div>
          </div>
          <NavbarMobile {...props} />
        </Headroom>
      </MobileScreen>
    </Fragment>
  );
}

const mapStateToProps = ({ user }) => ({
  userInfo: user.userId
    ? {
      image: user.avatar ? `${config.RESOURCE_URL}/${user.avatar}` : fallbackUserAvatar,
      userId: user.userId,
      name: user.name,
    }
    : null,
});

const mapActionToProps = {
  logout,
  openLoginModal,
  openSignUpModal,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapActionToProps
  )(NavBar)
);



// WEBPACK FOOTER //
// ./src/components/TopBar/Navbar.jsx